import { getRgObjectsOfType as n, RG_TYPE as o } from "@project-rouge/rg-core";
import { getApartmentTypeCounts as m } from "./index2.js";
const f = (t, e) => {
  const r = n(t, o.Apartment).filter((p) => p.data.level === e);
  return m(r);
};
export {
  f as getLevelApartmentTypeCounts
};
//# sourceMappingURL=index4.js.map
